import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useRegionSize
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useElementBoundary } from '@tencent/glue-react-boundary';
import { useRegionInstance } from '../context/reigon';
export function useRegionSize() {
  var region = useRegionInstance();

  var _useElementBoundary = useElementBoundary(function () {
    return true;
  }, function (size) {
    region.updateRegionSize({
      width: size.width,
      height: size.height
    });
  }, {}),
      _useElementBoundary2 = _slicedToArray(_useElementBoundary, 1),
      ref = _useElementBoundary2[0];

  return [ref];
}